import { LinearGradient } from 'expo-linear-gradient';
import { useVideoPlayer, VideoView } from 'expo-video';
import { useEffect } from 'react';
import { View } from 'react-native';

import vidaAppVideo from '@/assets/videos/onboarding/vida-app.mp4';

const HERO_GRADIENT_COLORS = ['#001C42', '#0066CC', '#A6D3FF'] as const;
const PHONE_FRAME_BG = '#E7EEFF';

/** Private to TransitionToNativeAppScreen — the looping app preview in a phone frame. */
export function HeroVideo() {
  const player = useVideoPlayer(vidaAppVideo, (p) => {
    p.loop = true;
    p.muted = true;
    p.play();
  });

  // On web the underlying <video> element only exists once VideoView mounts, so
  // the play() in the create callback above can no-op (the player has no element
  // yet). Re-attempt play after mount, and again whenever the source becomes
  // ready — muted + playsInline (below) keeps it within browser autoplay policy.
  useEffect(() => {
    const tryPlay = () => {
      player.muted = true;
      player.play();
    };
    tryPlay();
    const sub = player.addListener('statusChange', ({ status }) => {
      if (status === 'readyToPlay') tryPlay();
    });
    return () => sub.remove();
  }, [player]);

  return (
    <LinearGradient
      colors={HERO_GRADIENT_COLORS}
      locations={[0, 0.52, 1]}
      start={{ x: 0.5, y: 0 }}
      end={{ x: 0.5, y: 1 }}
      style={{
        width: '100%',
        height: '100%',
        borderRadius: 24,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <View
        style={{
          position: 'absolute',
          left: '50%',
          width: 272,
          height: 520,
          // The frame is bottom-anchored and bleeds 40px off the bottom (emerge
          // effect); the top gap is whatever the container height allows. The hero
          // container is sized in TransitionToNativeAppScreen so the gap stays ~60px
          // when stacked, and matches the left column on desktop.
          bottom: -40,
          marginLeft: -136,
          borderRadius: 40,
          backgroundColor: PHONE_FRAME_BG,
          padding: 14,
          overflow: 'hidden',
        }}
      >
        <View
          style={{
            width: '100%',
            height: '100%',
            borderRadius: 28,
            overflow: 'hidden',
            backgroundColor: '#000',
          }}
        >
          <VideoView
            player={player}
            style={{ width: '100%', height: '100%' }}
            contentFit='cover'
            nativeControls={false}
            allowsPictureInPicture={false}
            // Required for muted autoplay on web / iOS Safari — without it the
            // browser blocks inline autoplay (tries to go fullscreen on gesture).
            playsInline
          />
        </View>
      </View>
    </LinearGradient>
  );
}
